module.exports = __webpack_public_path__ + "static/media/gift02_zhCht.a74d6312.png";